import { Grid, SxProps, Theme } from "@mui/material";
import { useContext } from "react";
import { LayoutsConfig, MainContext } from "../../context/MainContextProvider";

type AccordionRootProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme> | undefined;
};

export function AccordionRoot({ children, sx }: AccordionRootProps) {
  const { layout } = useContext(MainContext)
  return (
    <Grid
      sx={{
        padding: { sm: "10px", xs: "5px" },
        flexDirection: "row",
        display: "flex",
        cursor: "pointer",
        backgroundColor: "rgba(217, 217, 217, 0.1)",
        borderRadius: 2,
        marginTop: "8px",
        marginBottom: "8px",
        boxShadow: layout == LayoutsConfig.LayoutTwo ? "2px 2px 8px rgba(0, 0, 0, 0.3)" : undefined,
        ...sx,
      }}
      container
    >
      {children}
    </Grid>
  );
}
